var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.preloader),expression:"preloader"}],staticClass:"preloader"},[_c('img',{attrs:{"src":"/assets/img/Spinner-1s-200px.apng","alt":"Carregando..."}})])}
var staticRenderFns = []

export { render, staticRenderFns }